import { Currency } from '@/core/currency/interfaces';

const TWD: Currency = {
    name: 'New Taiwan Dollar',
    demonym: 'New Taiwan',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '901',
    symbol: 'NT$',
    symbolNative: '圓',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'TWD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default TWD;
